<script>
import { mapActions, mapState } from "pinia";
import Popin from "@/components/molecules/popin";
import { LayoutTypes } from "@/services/context/layout-helper";
import { typeEtatPanierAvalaible } from "@/services/panier/panier-helper";
import { useInteractionDoneTracking } from "@/mixins/tracking/interaction-done";
import { useUpdateCartTracking } from "@/mixins/tracking/update-cart";
import { usePanierStore } from "@/store/panier";
import { useContextStore } from "@/store/context";

export default {
  name: "EtatPanier",
  props: {
    isControleTunnel: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ["closed", "ignore"],
  setup() {
    const { trackEvent } = useInteractionDoneTracking();
    const { trackUpdateCart } = useUpdateCartTracking();
    return { trackEvent, trackUpdateCart };
  },
  data() {
    return {
      initialPanier: []
    };
  },
  components: {
    Popin
  },
  computed: {
    ...mapState(useContextStore, ["layout"]),
    ...mapState(usePanierStore, ["etatPanier", "lignes"]),
    component() {
      if (this.isEtatPanierAvalaible) {
        return defineAsyncComponent(
          lazyComponents[
            `/components/organisms/etat-panier/${this.etatPanier.type}/${this.layout}.vue`
          ]
        );
      }
      return "div";
    },
    isMobile() {
      return this.layout === LayoutTypes.mobile;
    },
    indisponibles() {
      return this.etatPanier.indisponibles;
    },
    quantiteInsuffisante() {
      return this.etatPanier.quantiteInsuffisante;
    },
    isEtatPanierAvalaible() {
      return (
        this.etatPanier &&
        typeEtatPanierAvalaible.some((type) => this.etatPanier.type === type)
      );
    }
  },
  methods: {
    ...mapActions(usePanierStore, {
      mergePaniers: "mergePaniers",
      checkStatus: "checkStatus",
      setEtatPanier: "setEtatPanier"
    }),
    show() {
      this.$refs.popin.show();
      if (this.isControleTunnel) {
        if (this.quantiteInsuffisante.length > 0) {
          this.trackProductsDeleted(this.quantiteInsuffisante, true);
        }
        if (this.indisponibles.length > 0) {
          this.trackProductsDeleted(this.indisponibles, false);
        }
        this.trackEvent({
          event: trackingCodes.EVENTS.popinControleStockOuverture,
          categoryGA: trackingCodes.EVENTS.popinControleStockOuverture,
          pageType: trackingCodes.PAGETYPE.cart
        });
      }
    },
    hide() {
      this.$refs.popin.hide();
      if (this.isControleTunnel) {
        this.trackEvent({
          event: trackingCodes.EVENTS.popinControleStockFermeture,
          categoryGA: trackingCodes.EVENTS.popinControleStockFermeture,
          pageType: trackingCodes.PAGETYPE.cart
        });
      }
    },
    trackProductsDeleted(productsList, isInsuffisant) {
      let productsDeleted = [];
      productsList.forEach((product) => {
        var panierProduct = this.initialPanier.find((p) => p.id === product.id);
        productsDeleted.push({
          ...panierProduct,
          quantity: isInsuffisant
            ? product.old_quantite - product.new_quantite
            : panierProduct.quantite
        });
      });
      this.trackUpdateCart({
        products: productsDeleted,
        method: "delete",
        context: `${trackingCodes.LABELGA.ControleStock}${trackingCodes.CONTEXTPANIER.SupprimerDuPanier}`
      });
    },
    async complete() {
      await this.mergePaniers();
      this.setEtatPanier(null);
      this.hide();
      this.$emit("closed");
    },
    async ignore() {
      await this.checkStatus({
        apiParams: {
          checkPanierDB: false,
          isLocalSync: false,
          checkStockDrive: false
        }
      });
      this.setEtatPanier(null);
      this.hide();
      this.$emit("ignore");
    }
  },
  created() {
    this.initialPanier = this.lignes;
  }
};
</script>

<template>
  <div>
    <Popin
      ref="popin"
      size="lg"
      aria-label="Etat panier"
      :page-back="isMobile"
      @cancelled="ignore()"
    >
      <component
        :is="component"
        v-if="isEtatPanierAvalaible"
        :etat-panier="etatPanier"
        :indisponibles="indisponibles"
        :quantite-insuffisante="quantiteInsuffisante"
        @complete="complete"
        @ignore="ignore()"
      />
    </Popin>
  </div>
</template>

<style lang="scss" scoped>
</style>
